module.exports = __webpack_public_path__ + "ef6b8b64e4ce5b0ff9ee69ada5f423af.MP3";